<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.line_id" allowClear show-search option-filter-prop="children"
                      placeholder="请选择发布平台" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="平台分类">
            <a-select v-model="searchForm.platform" allowClear show-search option-filter-prop="children"
                      placeholder="请选择平台分类" style="width: 100%">
              <a-select-option v-for="item in PLATFORM" :key="item.key" :value="item.key">{{
                item.value
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="标识">
            <a-input v-model="searchForm.flag" allowClear placeholder="请输入标识" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="类型">
            <a-select v-model="searchForm.type_id" allowClear show-search option-filter-prop="children"
                      placeholder="请选择类型" style="width: 100%">
              <a-select-option v-for="item in contactTypeList" :key="item.id" :value="item.id">{{
                item.name
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="内容">
            <a-input v-model="searchForm.contact" allowClear placeholder="请输入内容" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="创建人员">
            <a-input v-model="searchForm.creator" allowClear placeholder="请输入创建人员" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="更新人员">
            <a-input v-model="searchForm.updator" allowClear placeholder="请输入更新人员" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="创建时间">
            <v-range-picker v-model="searchForm.created_at" allowClear @change="onCreateAtChange"
                            :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="更新时间">
            <v-range-picker v-model="searchForm.updated_at" @change="onUpdateAtChange"
                            :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select v-model="searchForm.status" allowClear show-search option-filter-prop="children"
                      placeholder="请选择状态" style="width: 100%">
              <a-select-option value="1">
                启用
              </a-select-option>
              <a-select-option value="2">
                禁用
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="ID">
            <a-input v-model="searchForm.id" allowClear placeholder="请输入ID" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="控制配置">
            <a-select v-model="searchForm.control_type" allowClear show-search option-filter-prop="children"
                      placeholder="请选择控制配置" style="width: 100%">
              <a-select-option value="1">官方信息</a-select-option>
              <a-select-option value="2">模块功能</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="模块名称">
            <a-input v-model="searchForm.module_name" allowClear placeholder="请输入模块名称" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAdd">新增</a-button>
        <a-button type="primary" icon="plus-circle" @click="handleAddType" style="margin-left: 10px;">类型管理</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 10px" @click="search">查询</a-button>
        <a-button type="primary" ghost icon="delete" @click="handleClear">清空</a-button>
        <!-- <a-button icon="sync">刷新表格</a-button> -->
      </div>
    </div>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :columns="columns" :loading="loading" :data-source="data" :scroll="{ x: true }"
             :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="user_id" slot-scope="text, record"> {{ record.user_name | fillBlank }} ({{ text }}) </template>
      <template slot="project" slot-scope="text, record">
        <span>{{ getOrg(record) }}</span>
      </template>
      <template slot="platform" slot-scope="text">
        <span>{{ showName('PLATFORM', text) }}</span>
      </template>
      <template slot="type_id" slot-scope="text,record">
        <span>{{ record.contactType && record.contactType.name ? record.contactType.name:'-' }}</span>
      </template>
      <template slot="contact" slot-scope="text,record">
        <!-- {{ record }} -->
        <span v-html="record.contact" v-if="record.contactType && record.contactType.format === '3'"
              class="publicInformationSet-rich-text"></span>
        <img v-if="record.contactType && record.contactType.format === '2'" :src="record.oss_domains +'/'+ record.contact" class="img-width"
             @click="handlePreview(record.oss_domains + '/' + record.contact)" />
        <span v-if="record.contactType && record.contactType.format === '1'">{{ text }}</span>
      </template>
      <!-- <template slot="contact" v-if="record.type_id === '1'" slot-scope="text,record">
        {{ text }}
      </template> -->
      <template slot="user_id" slot-scope="text, record">
        <p style="margin:0;">创建：{{ record.creator_name }}({{ record.creator_number }})</p>
        <p style="margin:0;">更新：{{ record.updator_name }}({{ record.updator_number }})</p>
      </template>
      <template slot="create_at" slot-scope="text, record">
        <p style="margin:0;">创建：{{ time(record.created_at) }}</p>
        <p style="margin:0;">更新：{{ time(record.updated_at) }}</p>
      </template>
      <template slot="status" slot-scope="text, record">
        <a-switch :checked="format(Number(record.status))" checked-children="启用" un-checked-children="禁用"
                  @change="(val) => checkedChange(val, record)" />
      </template>
      <template slot="operator" slot-scope="text, record">
        <div class="flex-sb">
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" danger @click="handleTableCommand('delete', record)">删除</a-button>
        </div>
      </template>
    </a-table>
    <!-- 图片预览 -->
    <a-modal width="40%" :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%;padding: 15px;" :src="previewImage" />
    </a-modal>
    <!-- 添加 -->
    <addFrequency v-model="visible" :isEdit="isEdit" :platformList="platformList" :PLATFORM="PLATFORM" :FORMAT="FORMAT"
                  :contactTypeList="contactTypeList" :params="waitItem" @handleOver="getList" />
    <!-- 类型管理 -->
    <typeManage v-model="visibleType" :params="waitItem" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, onUnmounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { strategyCommand } from './business/tableLogic'
import { searchForm, columns } from './business/frequencySet'
import pagination from '@/composables/pagination'
import addFrequency from './addFrequency.vue'
import compuedFun from './computed'
import api from '@/api/'
import moment from 'moment'
import typeManage from './typeManage.vue'
export default {
  components: { addFrequency, typeManage },
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      times: [],
      platformList: [],
      searchForm: { ...searchForm },
      contactTypeList: [],
      previewVisible: false, // 图片预览
      previewImage: '',
      visibleType: false
    })

    onMounted(async () => {
      await methods.getList()
      methods.getPlatform()
      methods.getContactType()
    })

    const methods = {

      handlePreview(url) {
        state.previewImage = url
        state.previewVisible = true
      },
      onUpdateAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.searchForm.updated_at = []
          return
        }
        _this.searchForm.updated_at = [
          Number(moment(dateString[0]).startOf('day').format('X')),
          Number(moment(dateString[1]).endOf('day').format('X')),
        ]
      },
      onCreateAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.searchForm.created_at = []
          return
        }
        _this.searchForm.created_at = [
          Number(moment(dateString[0]).startOf('day').format('X')),
          Number(moment(dateString[1]).endOf('day').format('X')),
        ]
      },
      time(time) {
        return (time = moment(time * 1000).format('YYYY-MM-DD HH:mm:ss'))
      },
      search() {
        _this.pagination.current = 1
        this.getList()
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      },
      handleAddType() {
        _this.visibleType = true
      },
      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },
 checkedChange(val, record) {
    const params = {
        id: record.id,
        status: val ? 1 : 2,
        project: record.project,
        staff_style: record.staff_style,
        type: record.type,
        flag: record.flag,
        platform: record.platform,
        control_type: record.control_type
    }
    const updateRecord = (status) => {
        record.status = status
        this.$message.success('操作成功~')
        this.getList()
    }
    const handleError = () => {
        record.status = !val
    }
    const handleResponse = (res) => {
        if (res.code === '000000') {
            updateRecord(val)
        } else {
            handleError()
        }
    }
    const handleConfirm = async () => {
        try {
            const res = await api.contactUpdate(params)
            handleResponse(res)
        } catch (error) {
            handleError()
        }
    }
    if (!val) {
        this.$confirm({
            title: '禁用',
            content: '禁用后，会影响历史数据使用该类型的公共信息展示。确认禁用？',
            cancelText: '取消',
            okText: '确认',
            async onOk() {
                await handleConfirm()
            },
        })
    } else {
        handleConfirm()
    }
},

      async getList() {
        _this.loading = true
        const [start_date, end_date] = state.times
        _this.searchForm.start_date = start_date
        _this.searchForm.end_date = end_date
        const res = await api.contactList({
          ...state.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize,
        })
        const frequencyList = res?.data?.list || []
        const pagination = res?.data?.pagination || _this.pagination
        _this.data = frequencyList
        _this.pagination.total = pagination.total
        _this.loading = false
      },
      getOrg(record) {
        const obj = state.platformList.find(
          (item) =>
            Number(item.project) === Number(record.project) &&
            Number(item.staff_style) === Number(record.staff_style) &&
            Number(item.type) === Number(record.type)
        )
        return obj ? obj.org : ''
      },
      getType(record) {
        const obj = _this.contactTypeList.find(
          (item) =>
            Number(item.id) === Number(record.type_id)
        )
        return obj ? obj.name : ''
      },
      async getPlatform() {
        const res = await api.LineList()
        state.platformList = res.data
      },
      async getContactType() {
        const res = await api.contactTypeListData()
        state.contactTypeList = res.data.list.filter((item) => {
          return item.status === 1
        })
      },
      changeIsShow(params) {
        api.updateInterviewIsShow(params).then((res) => {
          this.getList()
        })
      },
      format(value) {
        return value === 1
      },
      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...compuedFun(),
      ...methods,
    }
  },
}
</script>
<style lang="less" scoped>
.ant-form-item{
  margin-bottom: 12px!important;
}

.img-width{
  cursor: pointer;
  width: 60px;
  height: 50px;
  width: 100%;
  object-fit: contain;
}
</style>
<style lang="less">
.publicInformationSet-rich-text {
  img {
    width: 60px;
    height: 50px;
    width: 100%;
    object-fit: contain;
  }
}
</style>
